<div class="w-100 h-100 d-flex flex-column" *ngIf="agreement$">
  <app-title></app-title>

  <div class="flex-grow-1 pb-2" style="overflow: auto;">

    <mat-card class="col-12 mb-4" style="margin: auto">
      <div class="align-items-center text-center my-2 w-100">
        <span matPrefix class="font-weight-bold">
          {{ contract.patientName}}&nbsp;
        </span>
        <span matPrefix class="font-weight-bold">
          ({{ insurer.displayedInsurerId }}-{{ contract.cardId }})&nbsp;
        </span>
      
      </div>
    </mat-card>
    <mat-card class="col-12 lead mb-4" style="margin: auto" [innerHTML]="agreement$ | async | safeHtml">
    </mat-card>
    <div 
        (click)="toggleAgreement()" 
        class="btn col-12 checkbox bg-acblue d-flex justify-content-start"
        style="font-size: 20px"
      >
        <mat-checkbox
          color="primary"
          [checked]="agreementCheck.value"
          [disabled]="true"
          [disableRipple]="true"
        >
          {{ "I_AGREE" | translated }}
        </mat-checkbox>
      </div>
  </div>
  <!-- <div class="d-flex flex-row align-self-center">    
    <div class="align-self-center text-center mt-2 mb-3 px-md-5 agreement-text">
      {{ "AGREEMENT_TEXT_CLICK_TO_CONTINUE" | translated }}
    </div>
  </div>   -->
  <div class="d-flex flex-row justify-content-between">
    <div class="d-flex">
      <app-btn [dataTxt]="'BACK'" (callback)="onClickRetour()" [icon]="'chevron-left'" [iconLocation]="'left'"
        [disabled]="dobType === undefined"></app-btn>
    </div>
    <div class="d-flex text-right">
      <app-btn [dataTxt]="'NEXT'" [classes]="'btnAnimation'" (callback)="onClickOk()" [icon]="'chevron-right'"
        [iconLocation]="'right'" [disabled]="agreementCheck.value == false"></app-btn>
    </div>
  </div>
</div>